import { gql } from '@apollo/client';

import { activityAnswerFragment, activityFragment } from '@ts-core/modules/activities/graphql/fragments';

export const studentActivityFragment = gql`
  fragment StudentActivity on Activity {
    ...Activity
    answer @type(name: "ActivityAnswer") {
      ...ActivityAnswer
    }
    createdBy {
      id
      name
    }
  }
  ${activityFragment}
  ${activityAnswerFragment}
`;
